var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-flatpickr-component',_vm._g({staticClass:"vuestic-date-picker",class:{'has-value': _vm.valueProxy && _vm.valueProxy.length},attrs:{"config":_vm.fullConfig},model:{value:(_vm.valueProxy),callback:function ($$v) {_vm.valueProxy=$$v},expression:"valueProxy"}},_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91738e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vuestic-theme/vuestic-components/vuestic-date-picker/VuesticDatePicker.vue
// module id = ovwP
// module chunks = 98